export default "__VITE_ASSET__83b23fd3__"